import type { ContentfulEventFragment } from '@/graphql/contentful/api';
import { useAnchor } from '@/hooks/useAnchor';
import { useRouter } from '@/hooks/useRouter';
import { useUser } from '@/hooks/useUser';
import { paths } from '@/lib/paths';
import { useCommonModalProviderContext } from '@/providers/CommonModalProvider';

export type urlEventTypeEnum =
  | 'Get my Breitling NFT'
  | 'Campaign Newsletter'
  | 'Warranty Extension'
  | 'Newsletter';

export const useHandleUrlTrigger = (
  urlTrigger?: ContentfulEventFragment | null,
) => {
  const {
    snapshot: { isAuthenticated },
  } = useUser();
  const { asPath, push } = useRouter();
  const {
    openCampaignNewsletterModal,
    setGetMyNFTModalStatus,
    setWarrantyExtensionModalStatus,
  } = useCommonModalProviderContext();
  const handleUrlTrigger = () => {
    if ((urlTrigger?.type as urlEventTypeEnum) === 'Get my Breitling NFT') {
      setGetMyNFTModalStatus(true);
    } else if (
      (urlTrigger?.type as urlEventTypeEnum) === 'Campaign Newsletter'
    ) {
      openCampaignNewsletterModal(urlTrigger);
    } else if (
      (urlTrigger?.type as urlEventTypeEnum) === 'Warranty Extension'
    ) {
      if (isAuthenticated) {
        setWarrantyExtensionModalStatus(true);
      } else {
        push(paths.myAccount.login.url({ query: { next: asPath } }));
      }
    } else if ((urlTrigger?.type as urlEventTypeEnum) === 'Newsletter') {
      window.dispatchEvent(new Event('newsletter'));
    }
    //TODO implement other event here
  };
  return { handleUrlTrigger };
};

export const useHandleQuickLink = (
  url: string,
  urlTarget: string,
  urlTrigger?: ContentfulEventFragment | null,
  disableNavigationScrollToTop?: boolean | null,
) => {
  const { handleAnchorEvent } = useAnchor(
    url,
    urlTarget,
    disableNavigationScrollToTop,
  );
  const { handleUrlTrigger } = useHandleUrlTrigger(urlTrigger);

  const handleQuickLink = () => {
    if (urlTrigger) {
      handleUrlTrigger();
    } else {
      handleAnchorEvent();
    }
  };

  return {
    handleQuickLink,
  };
};
